import { lazy, Suspense } from 'react'

import SubmissionPage from './features/submission/SubmissionPage'

const AdminPage = lazy(() => import('./features/admin/AdminPage'))
const ContributorTermsPage = lazy(() => import('./features/legal/ContributorTermsPage'))

export function App() {
  const path = window.location.pathname.replace(/\/$/, '')
  if (path === '/admin' || path === '/admin/approved') {
    return (
      <Suspense fallback={<div className="route-loading">Opening the nug shot repository…</div>}>
        <AdminPage />
      </Suspense>
    )
  }

  if (path === '/contributor-terms') {
    return (
      <Suspense fallback={<div className="route-loading route-loading--light">Opening contributor terms…</div>}>
        <ContributorTermsPage />
      </Suspense>
    )
  }

  return <SubmissionPage />
}
